import React from 'react'
import { Route } from 'react-router-dom'
import KidDashboard from 'components/pages/kids/Dashboard'
import KidDetail from 'components/pages/kids/Kid'
import KidRewards from 'components/pages/kids/Rewards'

const KidRouter = () => {
  return (
    <>
      <Route path="/kids" exact>
        <KidDashboard />
      </Route>
      <Route path="/kids/:id" exact>
        <KidDetail />
      </Route>
      <Route path="/kids/:id/rewards" exact>
        <KidRewards />
      </Route>
    </>
  )
}

export default KidRouter
